import { render } from "./client-pj.vue?vue&type=template&id=c4ae0180"
import script from "./client-pj.vue?vue&type=script&lang=js"
export * from "./client-pj.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__